function dateConverter(UNIX_timestamp){
    var a = new Date(UNIX_timestamp);
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    
    var time = month + ' ' + date + ', ' + year;
    return time;
}

function numberWithCommas(x) {
    if(x)
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    else
        return ""
}

export const getPDF = function(estimate) {

    var url = "https://us-central1-keiki-262db.cloudfunctions.net/getPDF";

    var html = "<html>";
     html = html + "<head>";
     html = html + "<style>";
     html = html + "h2 {font-size:17px; font-family:arial, helvetica, sans-serif; font-weight:600}";
     html = html + ".lineItem {font-size:8px; line-height:13px; font-family:arial, helvetica, sans-serif; }";
     html = html + "</style>";
     html = html + "</head>";
     html = html + "<body>";

     html = html + "<img src='https://app.allthingseq.com/logo.png' style='height:89px; margin-left:-12px;' />";
     html = html + "<br />";
     html = html + "<div class='lineItem' >9066 N. 114th Street</div>";
     html = html + "<div class='lineItem' >Scottsdale, AZ 85259</div>";
     html = html + "<div class='lineItem' style='color:gray;' >https://app.allthingsEQ.com</div>";
     html = html + "<h2>Estimate</h2>";
     html = html + "<div class='lineItem' style='color:#DF8F43' >Prepared for " + estimate.schoolName + ".</div>";
     html = html + "<div class='lineItem' style='color:gray' >" + dateConverter(new Date().getTime()) + "</div>";
     html = html + "<br />";
     html = html + "<div>";
     html = html + "<div class='lineItem' style='width:321px; display: inline-block; font-weight:600; color: gray;'>Name</div>";
     html = html + "<div class='lineItem' style='width:50px; display: inline-block; font-weight:600; color: gray; text-align:right'>Quantity</div>";
     html = html + "<div class='lineItem' style='width:75px; display: inline-block; font-weight:600; color: gray; text-align:right'>Price</div>";
     html = html + "<div class='lineItem' style='width:75px; display: inline-block; font-weight:600; color: gray; text-align:right'>Total</div>";
     html = html + "</div>";
     html = html + "<hr />";

    for(var i = 0; i < estimate.items.length; i++) {
         html = html + "<div>";
         html = html + "<div class='lineItem' style='width:321px; display: inline-block;'>" + trim(estimate.items[i].name, 66) + "</div>";
         html = html + "<div class='lineItem' style='width:50px; display: inline-block; text-align:right'>" + estimate.items[i].qty + "</div>";
         html = html + "<div class='lineItem' style='width:75px; display: inline-block; text-align:right'>$" + estimate.items[i].listPrice + "</div>";
         html = html + "<div class='lineItem' style='width:75px; display: inline-block; text-align:right'>$" + estimate.items[i].total + "</div>";
         html = html + "</div>";
    }
     html = html + "<div>";
     html = html + "<div class='lineItem' style='width:321px; display: inline-block; font-weight:600;'></div>";
     html = html + "<div class='lineItem' style='width:50px; display: inline-block; font-weight:600;'></div>";
     html = html + "<div class='lineItem' style='width:75px; display: inline-block; font-weight:600; text-align:right'></div>";
     html = html + "<div class='lineItem' style='width:75px; display: inline-block; font-weight:600; text-align:right'>$" + numberWithCommas(estimate.orderTotal) + "</div>";
     html = html + "</div>";
    
     html = html + "<br />";
     html = html + "<div class='lineItem' style='color:gray' >Note: this estimate must be accepted within 15 days to be remain valid.</div>";

     html = html + "</body>";
     html = html + "</html>";

    var data = {
        "html" : html
      }

    fetch(url, {
        method: "POST", 
        cache: "no-cache",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
    })
    .then((response) => {
        console.log(response);
        if(response.ok) {
            return response.blob()
        } else {
        console.log("error1");  
        console.log(response);
        }
    })
    .then((blob) => {
        downloadFile(blob, "estimate.pdf");
    })
    .catch((error) => {
        // If there is any error you will catch them here
        console.log("error getting PDF for estimate: " + error);
    });
}


function downloadFile(blob, fileName){
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([blob], {type: "application/pdf"})

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob);
      return;
    } 

    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);
    var link = document.createElement('a');
    link.href = data;
    link.download=fileName;
    link.click();
  }


  function trim(value, maxLength) {
    if(value) {
        if(value.trim().length > maxLength)
            return value.trim().substring(0,maxLength) + "...";
        else
            return value.trim();
    } else return "";
  }


// WEBPACK FOOTER //
// ./src/assets/orders/orders.js